export enum ElementPermission {
	View = 'view',
	Edit = 'edit',
	Delete = 'delete',
	Export = 'export',
	Share = 'share',
	Publication = 'publication',
	Persist = 'persist',
	Link = 'link',
	Permissions = 'permissions',
	Data_catalog = 'data_catalog',
	List = 'list',
	Create = 'create',
}

export const PermissionDependencies: Record<string, Array<string>> = {
	[ElementPermission.Edit]: [ElementPermission.View],
};

export const ReverseDependencies: Record<string, Array<string>> = {
	[ElementPermission.View]: [ElementPermission.Edit],
};
